<template>
    <button
        class="d-flex align-content-center align-items-center justify-content-between"
        @click="$emit('sort', field)"
    >
        {{ label }}
        <span class="ml-1">
            <i v-if="isAscending" class="fa fa-sort-up"></i>
            <i v-else-if="isDescending" class="fa fa-sort-down"></i>
            <i v-else class="fa fa-sort text-muted"></i>
        </span>
    </button>
</template>

<script>
export default {
    name: 'SortButton',

    props: {
        field: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        currentSort: {
            type: String,
            default: '',
        },
    },

    computed: {
        isAscending() {
            return this.currentSort === this.field;
        },

        isDescending() {
            return this.currentSort === `-${this.field}`;
        },
    },
};
</script>
